// import React from "react";
// import { MdSearch, MdNotifications } from "react-icons/md";
// import "./HeaderUser.css";

// const HeaderUser = () => {
//   return (

//     <div className="header">
      
//       {/* FIRST ROW → Right side */}
//       {/* <div className="header-top">
        
        
//         <div className="search-bar">
//           <MdSearch className="search-icon" />
//           <input
//             type="text"
//             placeholder="Search for anything"
//             className="search-input"
//           />
//         </div> 

        
//          <div className="notification">
//           <MdNotifications className="notification-icon" />
//           <span className="notification-dot"></span>
//         </div>

//       </div> */}

//       {/* SECOND ROW → Left side */}
//       <div className="header-bottom">
//         <h1> Users Management</h1>
//       </div>

//       {/* <div className="headerp">
//         <p>manage and monitor users accounts</p>
//       </div> */}

//     </div>
//   );
// };

// export default HeaderUser;



import React from "react";
import "./HeaderUser.css";

const UserHeader = () => {
  return (
    <div className="user-header">
      <div className="user-header-content">
        <h1 className="user-header-title">Users Management</h1>
        <h3 className="user-header-subtitle">
          Manage and monitor user accounts
        </h3>
      </div>
    </div>
  );
};

export default UserHeader;
